import { Component, Input } from '@angular/core';
import { Insurant } from '@models/insurant';
import { InsurantsConfig, InsurantsFormConfig } from '@models/insurants-form-config';

@Component({
    selector: 'app-summary-insurants',
    templateUrl: './summary-insurants.component.html',
    styleUrls: ['./summary-insurants.component.scss'],
    standalone: false,
})
export class SummaryInsurantsComponent {
    @Input()
    public insurants: Insurant[];
    @Input()
    public insurantsFormConfig: InsurantsFormConfig;

    public getInsurantsByCategory(category?: string): Insurant[] {
        return this.insurants.filter((insurant) => insurant.category === category);
    }

    public getInsuranceRank(rankId: number, insurantConfig: InsurantsConfig): string {
        const ranks = Array.isArray(insurantConfig.insuranceRanks)
            ? insurantConfig.insuranceRanks
            : this.insurantsFormConfig.insurants.find((cfg) => cfg.category === insurantConfig.insuranceRanks)
                  ?.insuranceRanks;
        if (typeof ranks !== 'undefined' && Array.isArray(ranks)) {
            return ranks.find((rank) => rank.id === rankId)?.description || 'unbekannt';
        }
        return 'unbekannt';
    }

    public hideInsurantsFor(config: InsurantsConfig): boolean {
        return config.hideEmptySummary && this.getInsurantsByCategory(config.category).length === 0;
    }
}
